





















































import { Component, Watch } from 'vue-property-decorator';
import { HeaderList, List } from '@/components/Table/TableModel';
import { treatValue } from '@/utils/moneyTreatments';
import RowsTable from '@/components/Table/RowsTable.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import eventBus from '@/utils/eventBus';
import DateUtils from '@/utils/DateUtils';
import BasePagination from '@/components/BasePagination/BasePagination.vue';
import AdminService from '@/api/AdminService';
import ContextMenu from '@/components/ContextMenu/ContextMenu.vue';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';

import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';
import { formatTotalAndPendingCoins } from '@/utils/coinsHelper';
import { getWordInitials } from '@/utils/getWordInitials';

@Component({
  components: {
    Table,
    RowsTable,
    TextInput,
    ContextMenu,
    ContentContainer,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon
  }
})
export default class customerList extends BasePagination {
  constructor() {
    super();
  }
  service = new AdminService();
  customers: List = new List([], []);
  searchableFields = 'searchableFields=customer.name';
  keyOrder: string[] = [];

  @Watch('getFlags')
  onChange() {
    this.assignHeader();
  }

  mounted() {
    this.assignHeader();
  }

  reloadList(clearList?: boolean, refreshCurrent?: boolean, query?: string) {
    if (this.refreshing || this.maxItems) return;
    if (clearList) {
      this.resetPagination();
      this.customers.list = [];
    }

    this.$showLoaderWithLocker();
    this.refreshing = true;
    this.service
      .getCustomers({
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pagination: this.pagination,
        filters: this.query
      })
      .then((response: any) => {
        const { items, links } = response.data;

        if (refreshCurrent) {
          // refresh page and reinitilize pagination
          this.resetPagination();
          this.pagination = links.next;
          if (!links.next) this.maxItems = true;
          this.customers.list = this.addRowsCustomers(items);
          this.isLoading = false;
        } else {
          // refresh page and add items
          this.customers.list = this.customers.list.concat(
            this.addRowsCustomers(items)
          );
          if (!links.next) this.maxItems = true;
          this.pagination = links.next;
        }
      })
      .finally(() => {
        this.$hideLoader();
        this.isLoading = false;
        this.refreshing = false;
      });
  }

  assignHeader() {
    const { verifyFlag, flagKeys, keyOrder } = this;

    keyOrder.push('picture');
    keyOrder.push('name');
    keyOrder.push('spent');
    keyOrder.push('coins');
    keyOrder.push('last_seen');
    keyOrder.push('slot:options');

    const header = [];
    header.push(new HeaderList(`Picture`, 'none', '12px'));
    header.push(new HeaderList(`Customer name`, 'customer.name'));
    header.push(new HeaderList(`Total spent`, 'customer_totalSpent'));
    header.push(new HeaderList(`Total Coins`, 'customer_totalCoins'));
    header.push(new HeaderList(`Last seen`, 'customer.lastSeen'));
    header.push(new HeaderList('', 'none', '12px'));
    this.customers.header = header;
  }

  detail(event: any) {
    const modalConfig = {
      isOpen: true,
      component: 'adminCustomerDetails',
      data: event
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  addRowsCustomers(customersList: any[]): any[] {
    let rows: any[] = [];
    customersList.forEach((row: any) => {
      rows.push({
        name: `${row.customer.name || '-'} ${row.customer.lastname || ''}`,
        picture: row.image.id
          ? JSON.parse(row.image.publicPath).small
          : getWordInitials(`${row.customer.name} ${row.customer.lastname}`),
        spent: `$${treatValue(row.customer.totalSpent) || '0'}`,
        reward: treatValue(row.customer.totalRewards) || '0',
        coins: treatValue(row.customer.totalCoins) || '0',
        lifetimeCoins: treatValue(row.customer.lifetimeCoins) || '0',
        totalCoins: formatTotalAndPendingCoins(
          treatValue(row.customer.totalCoins) || '0',
          treatValue(row.customer.pendingCoins) || '0'
        ),
        visits: row.customer.totalVisits || '0',
        id: row.customer.id,
        last_seen: DateUtils.formatISODate(row.customer.lastSeen),
        joined: DateUtils.formatISODate(row.customer.createdAt)
      });
    });
    return rows;
  }
}
